


























































import { Route } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';

import { DistributionChart, KpisSuccess, Pivots, QueriesTable, RelatedTable, Search, UiProgressLinear } from '../components';

import { ApiEnum, KpiEnum } from '../enums';

import { AnalyticsMixin } from '../mixins/analytics.mixin';

import { GuardResolveFunction } from '../models';

import { ROUTER_CONSTS } from '../router/router.consts';

import { ANALYTICS_CONSTS } from '../store/analytics/analytics.consts';
import { CONFIG_CONSTS } from '../store/config/config.consts';
import { CONTEXT_CONSTS } from '../store/context/context.consts';

export default {
  name: 'queries',
  components: {
    KpisSuccess,
    DistributionChart,
    Pivots,
    RelatedTable,
    Search,
    QueriesTable,
    UiProgressLinear
  },
  mixins: [AnalyticsMixin],
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      kpis: CONFIG_CONSTS.getters.kpis
    }),
    kpisSuccessTitle: function (): string {
      if (!this.selectedId) {
        return this.messages.kpisSuccess.overall;
      } else {
        return this.$epb.utils.compileMessage(this.messages.kpisSuccess.selectedId, { terms: this.selectedId });
      }
    }
  },
  data: function () {
    return {
      loading: {
        distribution: false
      },
      messages: this.$epb.messages.analytics
    };
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      setQuery: CONTEXT_CONSTS.actions.setQuery
    }),
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      loadDistData: ANALYTICS_CONSTS.actions.loadDistData,
      loadSessionsData: ANALYTICS_CONSTS.actions.loadSessionsData
    }),
    loadData: async function (): Promise<void> {
      this.loading.distribution = true;
      try {
        await this.loadDistData(this.selectedId);
        this.loading.distribution = false;
        if (!this.selectedId) {
          if (this.kpis.includes(KpiEnum.SESSIONS) || this.kpis.includes(KpiEnum.QUERIES_PER_SESSION)) {
            await this.loadSessionsData();
          }
          await this.$refs.queriesTable.loadData({ resetAll: true });
        } else {
          await this.$refs.pivotsComponent.loadData();
          await this.$refs.relatedTable.loadData(true);
        }
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
      } finally {
        this.loading.distribution = false;
      }
    },
    onSelectedIdChange: async function (selectedId?: string): Promise<void> {
      if (selectedId === this.selectedId) {
        selectedId = undefined;
      }
      await this.setSelectedId(selectedId);
      this.loadData();
    },
    onQueryChange: async function (query: string): Promise<void> {
      this.contextWatchDisabled = true;
      await this.setQuery(query);
      this.$emit('contextChanged');
      this.contextWatchDisabled = false;
    }
  },
  beforeRouteLeave: async function (to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    if (!!this.context.query) {
      await this.onQueryChange(undefined);
      next({
        name: to.name,
        params: to.params,
        query: {
          ...to.query,
          [ROUTER_CONSTS.query.query]: undefined
        }
      });
    } else {
      next();
    }
  }
};
